export const LOGIN = "admin/auth/login";

export const SIGN_UP = "user/auth/signup";

export const CHANGE_PASSWORD = 'admin/auth/changePassword';

export const DASHBOARD = 'admin/auth/dashboard';

export const SUB_ADMIN = "admin/auth/subAdmin";

export const RESEND_OTP = "admin/auth/resendOtp";

export const VERIFY_OTP = "admin/auth/verifyOtp";

